import { GridValidRowModel } from '@mui/x-data-grid-pro'
import React from 'react'
import { useSelector } from 'react-redux'
import DataGridCell, {
  DataGridCellProps,
} from 'src/components/DataGrid/cells/DataGridCell/DataGridCell'
import UserAvatar from 'src/components/UserAvatar/UserAvatar'
import { AvatarSizes } from 'src/enums'
import { useTranslate } from 'src/localization/Trns'
import { UserListModel } from 'src/models/user.models'
import { selectUserIdFromState } from 'src/redux/selectors/auth.selectors'

import styles from './UserAvatarCell.style'

type UserAvatarCellProps<Row extends GridValidRowModel> = {
  user:
    | UserListModel
    | {
        id: string
        fullNameOrEmail: string
        initials: string
        avatarUrl?: string
        deactivated?: boolean
        truncatedFullNameOrEmail?: string
        hasFullName: boolean
      }
} & Omit<DataGridCellProps<Row>, 'icon' | 'text'>

const UserAvatarCell = <Row extends GridValidRowModel>(
  props: UserAvatarCellProps<Row>,
): React.ReactElement => {
  const { user, ...cellProps } = props
  const userId = useSelector(selectUserIdFromState)
  const translate = useTranslate()

  return (
    <DataGridCell
      icon={
        <UserAvatar
          css={`
            display: flex;
            margin: 2px 0;
          `}
          user={user}
          size={AvatarSizes.Small}
        />
      }
      text={
        <span css={styles}>
          {user?.id === userId
            ? translate('${userName} (you)', {
                userName:
                  user?.truncatedFullNameOrEmail || user?.fullNameOrEmail,
              })
            : user?.truncatedFullNameOrEmail || user?.fullNameOrEmail}
          {!props.user?.hasFullName && (
            <span className={'unregistered-label'}>
              {translate('(unregistered)')}
            </span>
          )}
        </span>
      }
      {...cellProps}
    />
  )
}

export default UserAvatarCell
